/**
 * packages/eds/src/utils — merge helper for components that support `preset`.
 * Spreads `presetProps` last so preset values override `props`.
 */
export function resolvePresetProps<Props>(
  props: Props,
  presetProps: Partial<Props> = {} as Partial<Props>,
): Props {
  return {
    ...props,
    ...presetProps,
  } as Props;
}
